// extracted by mini-css-extract-plugin
export default {"periodInfo":"ChartContainer_periodInfo__AkWVZ","chartLogo":"ChartContainer_chartLogo__kwqkT","chart":"ChartContainer_chart__qtv7o"};